<template>
    <div class="ui-search relative inline-block">
        <input
            v-model.trim="searchValue"
            class="ui-search__input text fz-16"
            type="text"
            :placeholder="placeholder"
            @keypress.enter="onSearchHandler"
            @change="$emit('change', $event)"
            @input="(e) => $emit('input', e.target.value)"
        >
        <div
            class="ui-search__icon ui-search__icon--search pointer"
            @click="onSearchHandler"
        >
            <SearchSvg />
        </div>
        <transition
            name="fade"
            mode="in-out"
        >
            <div
                v-show="searchValue"
                class="ui-search__icon ui-search__icon--clear pointer items-center justify-end"
                @click="cleanSearch"
            >
                <ClearSvg />
            </div>
        </transition>
        <div class="ui-search-slot">
            <slot />
        </div>
    </div>
</template>

<script>
import {defineComponent, ref, watch} from 'vue';

export default defineComponent({
    name: 'UISearch',
    components: {
        SearchSvg: () => import('@/assets/images/search.svg?inline'),
        ClearSvg: () => import('@/assets/images/icons/clear-cross.svg?inline'),
    },
    props: {
        placeholder: {
            type: String,
            default: () => '',
        },
        green: {
            type: Boolean,
            default: () => false,
        },
        inputValue: {
            type: String,
            default: () => '',
        },
    },
    emits: ['search', 'search-clean'],
    setup(props, context) {
        const searchValue = ref('');

        function onSearchHandler(e) {
            if (!searchValue.value) {
                return;
            }

            context.emit('search', searchValue.value);
        }

        function cleanSearch() {
            searchValue.value = '';
            context.emit('search-clean');
        }

        watch(searchValue, (newVal, oldVal) => {
            if (!newVal && !oldVal) {
                return;
            }

            if (!newVal) {
                context.emit('search-clean');
            }
        });

        watch(() => props.inputValue, (newVal) => {
            searchValue.value = newVal;
        });

        return {
            searchValue,
            onSearchHandler,
            cleanSearch,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/ui-search';
</style>
